import React, { useState } from 'react';
import { FormPurchase } from './form-purchase/form-purchase';
import { ModalApprovePurchase } from './modal-approve-purchase/modal-approve-purchase';
import { ProductPurchaseProps } from './types';
import { usePurchaseEmployee } from '../lib/hooks/use-purchase-employee/use-perchase-employee';
import { usePurchaseManager } from '../lib/hooks/use-purchase-manager/use-purchase-manager';
import { ModalBecomeManager } from './modal-become-manager/modal-become-manager';

export const ProductPurchase: React.FC<ProductPurchaseProps> = ({ product }) => {
    const [isShowPurchaseModal, setIsShowPurchaseModal] = useState(false);
    const [isShowBecomeManagerModal, setIsShowBecomeManagerModal] = useState(false);
    const [productCounter, setProductCounter] = useState(1);

    // , handleRequestEmployee
    const { handleCreateOrderEmployee } = usePurchaseEmployee({
        product,
        productCounter,
    });
    const { handlePurchaseManager, ownRequestsParameters } = usePurchaseManager({ product, productCounter });

    return (
        <>
            <FormPurchase
                product={product}
                productCounter={productCounter}
                ownRequestsParameters={ownRequestsParameters}
                setProductCounter={setProductCounter}
                // onShowBecomeManager={() => setIsShowPurchaseModal(true)}
                // onCreateRequestEmployee={handleRequestEmployee}
                onBuyProductManager={handlePurchaseManager}
                onCreateOrderEmployee={handleCreateOrderEmployee}
            />

            <ModalApprovePurchase
                isShow={isShowPurchaseModal}
                handleCreateOrder={handleCreateOrderEmployee}
                handleBecomeManager={() => {
                    setIsShowPurchaseModal(false);
                    setIsShowBecomeManagerModal(true);
                }}
                onClose={() => setIsShowPurchaseModal(false)}
            />
            <ModalBecomeManager isShow={isShowBecomeManagerModal} onClose={() => setIsShowBecomeManagerModal(false)} />
        </>
    );
};
